module.exports = __webpack_public_path__ + "components/page-header/static/icon-caret-down--white-c5e8011bf824a73557da02421febd342.svg";